import Modal from '../helpers/Modal';

export default class CreateAccountModal {
    constructor(root) {
        this.root = root;
        this.form_data = window.theme.forms.board_application;
        this.form_root = this.root.querySelector('.gform_wrapper, .gform_confirmation_wrapper');
        this.modal_title = this.root.querySelector('.js-create-account-modal-title');
        this.modal_subtitle = this.root.querySelector('.js-create-account-modal-subtitle');
        this.first_name_field = this.root.querySelector('.name_first input');
        this.last_name_field = this.root.querySelector('.name_last input');
        this.email_field = this.root.querySelector('input[type=email]');
        this.modal_cart_cta = this.root.querySelector('.js-create-account-modal-cart-cta');

        this.main_signup = this.root.querySelector('.js-create-account-modal-signup');
        this.main_success = this.root.querySelector('.js-create-account-modal-success');

        let url_params = new URLSearchParams(window.location.search);

        if(url_params.get('success') !== null) {
            this.main_signup.classList.add('--hidden');
            this.main_success.classList.remove('--hidden');
        }

        this.modal = new Modal(this.root);

        if(this.form_root && (this.form_root.classList.contains('gform_validation_error') || this.form_root.classList.contains('gform_confirmation_wrapper'))) {
            this.modal.open();
        }

        this.first_name_field.addEventListener('input', (event) => {
            this.updateNameField();
            this.validateName(this.first_name_field);
        });

        this.last_name_field.addEventListener('input', (event) => {
            this.updateNameField();
            this.validateName(this.last_name_field);
        });

        this.email_field.addEventListener('input', (event) => {
            this.modal_subtitle.innerText = this.email_field.value;

            if(this.email_field.value.trim() == '') {
                this.modal_subtitle.classList.remove('--active');
            } else {
                this.modal_subtitle.classList.add('--active');
            }
        });

        window.addEventListener('user-data-removed', (event) => {
            this.main_signup.classList.remove('--hidden');
            this.main_success.classList.add('--hidden');
            this.modal_title.innerText = '';
            this.modal_title.classList.remove('--active');
            this.modal_subtitle.innerText = '';
            this.modal_subtitle.classList.remove('--active');
        });

        if(window.theme.cart.isEmpty()) {
            this.modal_cart_cta.classList.add('--hidden');
        } else {
            this.modal_cart_cta.classList.remove('--hidden');
        }
    }

    validateName(field) {
        let arr = field.value.split(' ');

        for(var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }

        field.value = arr.join(' ');
    }

    updateNameField() {
        let name = this.first_name_field.value + ' ' + this.last_name_field.value;
        this.modal_title.innerText = name.trim();

        if(name.trim() == '') {
            this.modal_title.classList.remove('--active');
        } else {
            this.modal_title.classList.add('--active');
        }
    }
}
